import React from 'react';

import { createLocale } from 'locales';

import Typography from 'components-new/typography/typography';
import DateInput from 'components-new/date-input/date-input';

import { useOrganizationWeekPlanner } from 'state/context/organization/OrganizationWeekPlanner';

const localize = createLocale('organizationWeekPlannerLocales');
const freelancerLocalize = createLocale('freelancerAvailabilityLocales');

const DateFilter: React.FC = () => {
  const {
    tableParams: { onStartDateChange, onEndDateChange, currentPeriod },
  } = useOrganizationWeekPlanner();

  return (
    <div className="mt-4 flex flex-col gap-2">
      <Typography className="text-gray300" variant="heading-4" as="span">
        {localize('searchDates')}
      </Typography>

      <DateInput
        placeholder={localize('selectStartDate')}
        defaultValue={currentPeriod[0]}
        onChange={onStartDateChange}
      />

      <DateInput
        placeholder={localize('selectEndDate')}
        defaultValue={currentPeriod[1]}
        onChange={onEndDateChange}
        minDate={
          (currentPeriod[0] && currentPeriod[0].add(1, 'day').toDate()) ||
          undefined
        }
      />
      {currentPeriod[1] < currentPeriod[0] && (
        <Typography
          as="p"
          variant="body-medium"
          className="text-destructive mt-1"
        >
          {freelancerLocalize('startDateMustBeLessThanEndDate')}
        </Typography>
      )}
    </div>
  );
};

export default DateFilter;
